class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.rebuildProductNotification(parsedState);

    if (this.header) this.header.reveal();
    this.open();
  }

  rebuildProductNotification(item) {
    const container = document.getElementById('cart-notification-product');
    if (!container) return;

    container.innerHTML = '';

    if (item.image) {
      const image = document.createElement('img');
      image.className = 'cart-notification-product__image';
      image.src = item.image;
      image.alt = item.product_title || item.title || '';
      container.appendChild(image);
    }

    const content = document.createElement('div');
    content.className = 'cart-notification-product__content';

    const title = document.createElement('p');
    title.className = 'cart-notification-product__title';
    title.textContent = item.product_title || item.title || '';

    const price = document.createElement('p');
    price.className = 'cart-notification-product__price';
    price.textContent = new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: Shopify.currency.active || 'EUR',
    }).format((item.final_price || item.price) / 100);

    content.appendChild(title);
    content.appendChild(price);

    const freeCharmValues = [];
    const extraCharmValues = [];

    if (item.properties) {
      Object.keys(item.properties).forEach((key) => {
        const value = item.properties[key];

        if (!value) return;

        if (/^Charm\s\d+$/.test(key)) {
          freeCharmValues.push(value);
        }

        if (key.includes('Charm supplémentaire')) {
          extraCharmValues.push(value);
        }
      });
    }

    const freeBlock = this.createCharmBlock('Charms gratuits', freeCharmValues);
    const extraBlock = this.createCharmBlock('Charms supplémentaires', extraCharmValues);

    if (freeBlock) content.appendChild(freeBlock);
    if (extraBlock) content.appendChild(extraBlock);

    container.appendChild(content);
  }

  createCharmBlock(titleText, values) {
    if (!values || !values.length) return null;

    const charms = document.createElement('div');
    charms.className = 'cart-notification-charms';

    const title = document.createElement('p');
    title.className = 'cart-notification-charms__title';
    title.textContent = titleText;

    const list = document.createElement('div');
    list.className = 'cart-notification-charms__list';

    values.forEach((country) => {
      const pill = document.createElement('span');
      pill.className = 'cart-notification-charms__pill';
      pill.textContent = country;
      list.appendChild(pill);
    });

    charms.appendChild(title);
    charms.appendChild(list);

    return charms;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedHtml.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);